import useProfessionalQualificationAttribute from '@mp/hooks/useProfessionalQualificationAttribute';
import { useRollbar } from '@mp';

const useClearI9 = () => {
  const showClearI9Page = (requestUrl: string) => {
    window.open(requestUrl, '_blank');
  };

  return { showClearI9Page };
};

const useI9 = (professionalQualificationAttributeId: number | undefined) => {
  const { showClearI9Page } = useClearI9();

  const { notifyRollbar } = useRollbar();

  const { data, isLoading } = useProfessionalQualificationAttribute(
    professionalQualificationAttributeId as number,
  );

  const isComplete = data?.metadata ? !data.metadata.webhook_pending : false;

  return {
    isComplete,
    isLoading,
    showI9Page: () => {
      try {
        showClearI9Page(data?.metadata?.i9_pro_url);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('unable to open ClearI9', error);
        notifyRollbar({
          errorLabel: 'Unable to open ClearI9',
          args: {
            error,
          },
        });
      }
    },
  };
};

export default useI9;
